import { render, staticRenderFns } from "./BatchImportOrder.vue?vue&type=template&id=cc55b8f6&scoped=true"
import script from "./BatchImportOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchImportOrder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BatchImportOrder.vue?vue&type=style&index=0&id=cc55b8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc55b8f6",
  null
  
)

export default component.exports